// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import ElementUI from 'element-ui';
import './utils/axios'
import * as filters from './utils/filters' // 全局filter
import i18n from './lang'
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/flexible'
// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

 
Vue.config.productionTip = false
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

import VueAMap from 'vue-amap'
setTimeout(() => {
  Vue.use(VueAMap)
}, 0)
VueAMap.initAMapApiLoader({
  key: 'a9efe6500f4e3a2e270ac000719dbede',
  plugin: ['AMap.Autocomplete', 'AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MarkerClusterer', 'MarkerClusterer'],
  v: '1.4.4',
  uiVersion: '1.0'
})

// 加载过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
  ElementUI,
})



// WEBPACK FOOTER //
// ./src/main.js